import css from "styled-jsx/css";
import { MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH } from "constants/vp-sizes";

export const componentStyles = css.global`
  .sign-up-with-products-cards-homepage-first-fold-component {
    max-width: ${MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH + "px"};
    margin: auto;
    display: flex;
    flex-direction: column;
    .title-wrapper{
      display: flex;
      flex-direction: column;
      gap: 10px;
      text-align: center;
      padding-top: 50px;
    }
    .cards-wrapper{
    display: flex;
    flex-direction: row;
    gap: 20px;
    justify-content: center;
    align-items: center;
    padding-bottom: 50px;
    padding-top: 50px;
    }
    .buttons-wrapper{
      display: flex;
      flex-direction: row;
      justify-content: center;
      gap: 20px;
      .signup-button{
        width: 240px;
      }
    }
    .text-under-buttons{
      text-align: center;
      padding-top: 20px;
    }
  }
`;
